<div id="customCard-container">
    <div style="padding-bottom: 8px;">
        <div id="encryptedCardNumber"
            [ngClass]="{'adyenMaterial': true, 'inputActive': this.cardNumberisFocused || this.cardNumberHasValue}">

            <!-- <div id="encryptedCardNumberTitle" class="inputTitle" > -->
            <label id="encryptedCardNumberTitle" class="labelInput"
                [ngClass]="{'showLabel': this.cardNumberHasValue || this.cardNumberisFocused}">Número do cartão:</label>
            <!-- </div> -->

            <span data-cse="encryptedCardNumber" class="inputsCreditCard"></span>

            <div>
                <div class="pme-payment-icon pme-payment-icon-{{this.brandIcon}}"></div>
            </div>

            <div class="errorLabel">
                <label id="encryptedCardNumberError"></label>
            </div>
        </div>
    </div>

    <div style="padding-bottom: 8px;">
        <div id="holderName"
            [ngClass]="{'adyenMaterial': true, 'inputActive': this.cardNameisFocused || this.cardNameHasValue, 'cardFocused': this.cardNameisFocused }">
            <label id="holderNameTitle" class="labelInput"
                [ngClass]="{'showLabel': this.cardNameHasValue || this.cardNameisFocused}">Nome igual do cartão:
            </label>

            <input id="holderNameInput" autocomplete="cc-name" type="text" class="inputsCreditCard" maxlength="64"
                placeholder="Nome igual ao do cartão" [(ngModel)]="cardHolder" (focus)="cardNameisFocused = true"
                (blur)="cardNameisFocused = false" (input)="theresInputValue($event.target.value, 'cardName')">

            <div style="padding-top:8px;">
                <div class="errorLabel">
                    <label id="holderNameError"></label>
                </div>
            </div>
        </div>
    </div>


    <div class="display-utils-row display-utils-lt-sm-col display-utils-between display-utils-gap-8 display-utils-gt-xs-gap-8 display-utils-lt-sm-gap-8" style="padding-bottom: 8px;">
        <div style="flex:1;">
            <div id="encryptedExpiryDate"
                [ngClass]="{'adyenMaterial': true, 'inputActive': this.expiryDateisFocused || this.expiryDateHasValue}">

                <!-- <div id="encryptedExpiryDateTitle" class="inputTitle"> -->
                <label id="encryptedExpiryDateTitle" class="labelInput"
                    [ngClass]="{'showLabel': this.expiryDateHasValue || this.expiryDateisFocused}">Validade:</label>
                <!-- </div> -->

                <span data-cse="encryptedExpiryDate" class="inputsCreditCard"></span>
                <!-- <span data-cse="encryptedExpiryDate" class="inputsCreditCard" placeholder="Data de validade"  [ngClass]="{'ExpiryDate': this.nameHasValue}">   </span> -->
                <div class="errorLabel">
                    <label id="encryptedExpiryDateError"></label>
                </div>

            </div>
        </div>

        <div class="tooltip-container" style="flex:1;">
            <div id="encryptedSecurityCode"
                [ngClass]="{'adyenMaterial': true, 'inputActive': this.cvcisFocused || this.cvcHasValue}">

                <!-- <div id="encryptedSecurityCodeTitle" class="inputTitle" > -->
                <label id="encryptedSecurityCodeTitle" class="labelInput"
                    [ngClass]="{'showLabel': this.cvcHasValue || this.cvcisFocused}">Código de segurança (CVV):</label>
                <!-- </div> -->


                <span data-cse="encryptedSecurityCode" class="inputsCreditCard"></span>
                <!-- <mat-icon matSuffix matTooltip="São os dígitos no verso do seu cartão" matTooltipPosition="right">help</mat-icon> -->
                <div class="errorLabel">
                    <label id="encryptedSecurityCodeError"></label>
                </div>
            </div>

            <div class="tooltip display-utils-hidden" [ngClass]="{'tooltip-visible': cvvFocus}">
                <div class="arrow"></div>
                <img src="../../../../assets/images/tooltips-cvv/cvv.png" />
                <p>Código de 3 dígitos impresso no <b>verso</b> do seu cartão.</p>
            </div>
        </div>
    </div>
    


    <div class="tooltip-mobile" [ngClass]="{'tooltip-visible': cvvFocus}">
        <!-- <div class="arrow"></div> -->
        <svg class="arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <polygon points="0,20 10,0 20,20" />
        </svg>
        <img src="../../../../assets/images/tooltips-cvv/cvv.png" />
        <p>Código de 3 dígitos impresso no <b>verso</b> do seu cartão.</p>
    </div>

    <div style="padding-bottom: 8px;" *ngIf="this.hideConditions !== true">
        <div class="adyenMaterial">
            <!-- <div class="inputTitle">
                <label>Número de parcelas</label>
            </div> -->
            <div class="select">
                <select class="paymentOptions" required [(ngModel)]="this.selectedPaymentCondition" (change)="handleIstallments()">
                    <option [ngValue]="null" selected disabled>
                        NÚMERO DE PARCELAS...
                    </option>

                    <option *ngFor="let option of availablePaymentOptions;" [ngValue]="option.identifier">
                        {{option.installments}}X de {{option.installmentValue | currency: 'R$'}}
                    </option>
                </select>
            </div>
        </div>
    </div>
    <!-- Teste loading  -->
    <!-- <pme-loading></pme-loading>  -->
    <!--  -->
</div>
